import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import {observer} from "mobx-react-lite";
import FilterBarDateRange from "../dateRangeFilter/FilterBarDateRange";
import FilterBarSelectMenu from "../filterSelectMenu/FilterBarSelectMenu";
import FilterBarSpeed from "../filterSpeed/FilterBarSpeed";
import {useContext, useState} from "react";
import {UIStoreContext} from "../../context";
//import "./filter.scss";
import styles from "./filterbar.module.scss";
import {Box, Button, CircularProgress} from "@mui/material";
import {useLocation} from "react-router-dom";
import {FilterProps} from "../../common/filterProps";

import {DateTime} from "luxon";

import devicesListService from "../../client-api/services/devicesList";
import {SystemType} from "../../common/systemType";

//import searchIcon from "./icons/search_icon.svg";
import SearchIcon from '@mui/icons-material/Search';

import DetectionsStats from "../../components/performanceStats/DetectionsStats";

const classes: any[] = [
    {key: "All", value: "All"},
    {key: "ANIMAL", value: "Animal"},
    {key: "BACK_SWITCH", value: "Back Switch", type: SystemType.SwitchYard},
    {key: "CAR", value: "Vehicle"},
    {key: "END_OF_RAIL", value: "End of Rails", type: SystemType.SwitchYard},
    {key: "LOCOMOTIVE", value: "Locomotive"},
    {key: "OBSTACLE", value: "Obstacle"},
    {key: "PERSON", value: "Person"},
    {key: "WAGON", value: "Sideswipe", type: SystemType.SwitchYard}
];


const FilterBar = () => {
    const uiStore = useContext(UIStoreContext);
    const location = useLocation();
    const [filterTempState, setFilterTempState] = useState<FilterProps>(
        uiStore.getFilter()
    );

    const [classesList, setClassesList] = useState(classes);

    const [value2, setValue2] = useState([3, 150]);

    const handleChange2 = (newValue: any) => {
        setValue2(newValue);
    };

    const setTempSystem = (value: string, system_type: number, measurement: string, loco_name: string) => {
        setFilterTempState({
            ...filterTempState,
            selectedSystem: value,
            systemType: system_type,
            measurement: measurement
        });

        setClassesList(classes.filter((classObject: any) => (system_type === SystemType.SwitchYard.valueOf() && classObject.type === SystemType.SwitchYard.valueOf()) || !classObject.type))
    };

    const setTempClass = (value: string) => {
        setFilterTempState({...filterTempState, selectedClass: value});
    };

    const setTempSpeed = (value: any) => {

        setFilterTempState({...filterTempState, speed: value});

    };


    const setTempDate = (newDateObj: {
        startDate: DateTime;
        endDate: DateTime;
        key: string;
        label: string;
    }) => {
        setFilterTempState({...filterTempState, dateFilter: newDateObj});
    };

    const setTempLocation = (value: string) => {
        setFilterTempState({...filterTempState, location: value});
    };

    const setTempFilter = (value: string) => {
        setFilterTempState({...filterTempState, video_source: value});
    };

    const searchButtonOnClick = () => {
        const dateNowStartOfDay = DateTime.now().startOf("day");
        const selectedDateStartOfDay =
            filterTempState.dateFilter.endDate.startOf("day");
        const d = selectedDateStartOfDay.diff(dateNowStartOfDay).as("seconds");

        uiStore.setLatLngBounds("");

        if (d === 0) {
            uiStore.setFilter({
                ...filterTempState,
                dateFilter: {...filterTempState.dateFilter, endDate: DateTime.now()},
            });
        } else {
            uiStore.setFilter(filterTempState);
        }
    };

    return (
        <div data-testid={"filter"} className={styles.filterWrapper}>
            <div className={styles.searchPanelFilters}>

                {["/updates"].includes(location.pathname) || (

                    <FilterBarDateRange
                        date={filterTempState.dateFilter}
                        setDate={(newDate: {
                            startDate: DateTime;
                            endDate: DateTime;
                            key: string;
                            label: string;
                        }) => setTempDate(newDate)}
                    />


                )}
                <FilterBarSelectMenu
                    required={true}
                    value={filterTempState.selectedSystem}
                    values={(devicesListService.GetDevicesList().data.map((device: any) => device.tags ? {
                        key: device.id,
                        value: device.loco_name,
                        measurement: device.tags.measurement,
                        type: device.device_type
                    } : {key: device.id, value: device.loco_name, type: device.device_type}))}
                    setValue={(event: string, type: number, measurement: string, value: string) => setTempSystem(event, type, measurement, value)}
                    header={"Systems"}
                />
                {!(["/performanceReport"].includes(location.pathname) || ["/heatMap"].includes(location.pathname)) || (

                    <FilterBarSelectMenu
                        disabled={location.pathname !== "/performanceReport"  && location.pathname !== "/heatMap"}
                        value={filterTempState.selectedClass}
                        values={classesList}
                        setValue={(event: any) => setTempClass(event)}
                        header={"Classification"}
                    />
                )}
                {!["/performanceReport"].includes(location.pathname) || (
                    <FilterBarSpeed setValue={(value: any) => setTempSpeed(value)}/>
                )}

               <div className={styles.filterGroupSearch}>
                   <div></div>
                   <div >

                       <Button

                            startIcon={<SearchIcon/>}
                            variant={"contained"}
                            className={styles.searchButtonFilter}
                            //className={styles.filterBarButton}
                            onClick={searchButtonOnClick}
                        >
                            Search
                            {uiStore.filterApplyButtonDisabled && (
                                <CircularProgress color="inherit"
                                                  size={24}
                                                  sx={{

                                                      position: "absolute",
                                                      top: "50%",
                                                      left: "50%",
                                                      marginTop: "-12px",
                                                      marginLeft: "-12px",
                                                  }}
                                />
                            )}
                        </Button>
                   </div>
                </div>
            </div>


            {!["/performanceReport"].includes(location.pathname) || (
                <div className={styles.rightContainer}>
                    <DetectionsStats/>
                </div>
            )}
        </div>
    );
};

export default observer(FilterBar);
